import logo from "../../assets/images/logo.png";

export default function Hero() {
    return (
        <div className="relative top-0 left-0 w-full h-screen bg-cover bg-center bg-no-repeat -mt-20">
            <div className="absolute flex flex-col items-center justify-center gap-32 w-full h-full text-white">
                <img src={logo} alt="logo" className="w-1/2  lg:w-1/4" />
                <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-white">
                    <button
                        className="px-4 py-2 bg-transparent border-2 border-white rounded-md hover:bg-white hover:text-black w-64 font-bold"
                        onClick={() => {
                            window.location.href = "/reservierung";
                        }}
                    >
                        TISCH RESERVIEREN
                    </button>
                    <button
                        className="px-4 py-2 bg-transparaent border-2 border-white rounded-md hover:bg-white hover:text-black w-64 font-bold"
                        onClick={() => {
                            window.location.href = "/bestellen";
                        }}
                    >
                        ESSEN BESTELLEN
                    </button>
                    <button
                        className="px-4 py-2 bg-transparent border-2 border-white rounded-md hover:bg-white hover:text-black w-64 font-bold"
                        onClick={() => {
                            const target =
                                document.getElementById("speisekarten");
                            if (target) {
                                target.scrollIntoView({ behavior: "smooth" });
                            }
                        }}
                    >
                        SPEISEKARTEN
                    </button>
                </div>
            </div>
        </div>
    );
}
